module.exports = __webpack_public_path__ + "static/media/video-preview.5b07210e.jpg";